document.addEventListener('DOMContentLoaded', initSlideshow);
document.addEventListener('shopify:section:load', initSlideshow);

function initSlideshow(event) {
  const root = event.target || document;
  root.querySelectorAll('.splide.custom-slideshow').forEach(el => {
    if (el.classList.contains('is-initialized')) return;
    new Splide(el, {
      type      : 'loop',
      perPage   : 1,
      autoplay  : el.dataset.autoplay === 'true',
      interval  : parseInt(el.dataset.interval, 10) || 5000,
      arrows    : el.dataset.arrows === 'true',
      pagination: el.dataset.dots === 'true'
    })
    .on('mounted', () => el.classList.add('is-initialized'))
    // Slide nascoste (inattive e copie del loop): pulsanti fuori dall'ordine di tabulazione, dopo l'aggiornamento di aria-hidden da parte di Splide
    .on('mounted moved', () => setTimeout(() => syncHiddenSlides(el)))
    .mount();
  });
}

function syncHiddenSlides(el) {
  el.querySelectorAll('.splide__slide').forEach(slide => {
    const hidden = slide.getAttribute('aria-hidden') === 'true';
    slide.querySelectorAll('a[href], button').forEach(node => {
      if (hidden) node.setAttribute('tabindex', '-1');
      else node.removeAttribute('tabindex');
    });
  });
}
